<template>
	<v-row class="ma-0 pb-offset">
        <v-col cols="12" class="pa-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Import/Export</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Scarica modello per Import</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-btn class="mx-0" width="106" color="info" @click.native="downloadTemplate('/leads-downloadcsv/', 'leads.csv')">modello</v-btn>
                        </v-list-item-action>
                        <v-list-item-content></v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Carica file per Import</v-subheader>

                    <!-- Modalita di Import -->
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="mb-2">Modalita di Import</v-list-item-title>
                            <v-radio-group v-model="importMode" row dense class="mt-0">
                                <v-radio label="Crea o Aggiorna" value="create_or_update" color="primary"></v-radio>
                                <v-radio label="Solo Creazione" value="create_only" color="primary"></v-radio>
                                <v-radio label="Solo Aggiornamento" value="update_only" color="primary"></v-radio>
                            </v-radio-group>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- Criteri Matching (visibile se non "Solo Creazione") -->
                    <v-list-item v-if="importMode !== 'create_only'" class="pb-0">
                        <v-list-item-content class="py-0">
                            <v-list-item-title class="mb-2">Criteri di Matching</v-list-item-title>
                            <v-list-item-subtitle class="mb-3">
                                Seleziona i campi per identificare i lead esistenti. L'ordine determina la priorita.
                            </v-list-item-subtitle>
                            <v-select
                                v-model="matchingFields"
                                :items="availableMatchingFields"
                                item-text="text"
                                item-value="value"
                                label="Campi per il matching"
                                multiple
                                small-chips
                                deletable-chips
                                :menu-props="{'offset-y': true}"
                                outlined
                                dense>
                            </v-select>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="importMode !== 'create_only'" class="pt-0">
                        <v-list-item-content class="py-0">
                            <v-switch
                                v-model="matchingLogicAnd"
                                :label="matchingLogicAnd ? 'Tutti i campi devono corrispondere (AND)' : 'Primo campo che corrispondere (Cascata)'"
                                class="ml-2 mt-0"
                                inset
                                hide-details>
                            </v-switch>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- Info box -->
                    <v-list-item>
                        <v-alert type="info" text dense class="mb-0 mt-2" style="width: 100%">
                            <span v-if="importMode === 'create_only'">
                                Tutte le righe creeranno <strong>nuovi</strong> lead.
                            </span>
                            <span v-else-if="importMode === 'update_only'">
                                Solo i lead esistenti verranno aggiornati. I nuovi saranno ignorati.
                            </span>
                            <span v-else>
                                I lead trovati saranno aggiornati, altrimenti ne verranno creati di nuovi.
                                <br v-if="matchingFields.length > 0">
                                <small v-if="matchingFields.length > 0">
                                    Matching: <strong>{{ matchingFieldsLabel }}</strong>
                                    ({{ matchingLogicAnd ? 'tutti i campi' : 'primo match' }})
                                </small>
                            </span>
                        </v-alert>
                    </v-list-item>

                    <!-- File Input and Upload Button -->
                    <v-list-item>
                        <v-list-item-action class="ma-auto">
                            <v-btn color="info" :disabled="!leadsFile" width="106" :loading="loading" @click="uploadFile('leads-uploadcsv/', leadsFile)">upload</v-btn>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-file-input
                                class="ml-6"
                                v-model="leadsFile"
                                outlined dense
                                accept=".csv"
                                small-chips
                                hide-details
                                label="File">
                            </v-file-input>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-card-actions>

                </v-card-actions>

            </v-card>
        </v-col>

        <v-col cols="12" class="pa-0 pt-4">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Altre Impostazioni</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Task</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['leads_task']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Associazione Lead</v-list-item-title>
                            <v-list-item-subtitle>Permetti di associare dei task direttamente ai lead presenti in anagrafica
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-subheader>Documenti</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['leads_documents_association']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Associazione ai Documenti</v-list-item-title>
                            <v-list-item-subtitle>Permetti di associare i lead ai documenti (preventivi, opportunità, ordini, ecc.)
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-subheader>Notifiche</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['leads_notify_new']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Notifica Nuovi Lead</v-list-item-title>
                            <v-list-item-subtitle>Invia notifiche quando vengono creati nuovi lead via API
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="settings['leads_notify_new']">
                        <v-list-item-action>
                            <!-- spacer -->
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-autocomplete
                                v-model="settings['leads_notify_new_users']"
                                :items="usersOptions"
                                item-text="text"
                                item-value="value"
                                label="Utenti da notificare"
                                multiple
                                small-chips
                                outlined
                                dense
						        :menu-props="{'offset-y': true}"
                                hide-details="auto"
                                :loading="loadingUsers">
                            </v-autocomplete>
                        </v-list-item-content>
                    </v-list-item>

                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="pa-2 mx-3" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin.js'

    export default {
        name: 'leads-options',
		mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'lead',
                settings: {
                    'leads_task': false,
                    'leads_documents_association': false,
                    'leads_notify_new': false,
                    'leads_notify_new_users': [],
                },
                leadsFile: null,
                loading: false,
                usersOptions: [],
                loadingUsers: false,
                // Import configuration
                importMode: 'create_or_update',
                matchingFields: ['code', 'vat_number', 'fiscal_code', 'business_name'],
                matchingLogicAnd: false,
                availableMatchingFields: [
                    { text: 'Codice', value: 'code' },
                    { text: 'Partita IVA', value: 'vat_number' },
                    { text: 'Codice Fiscale', value: 'fiscal_code' },
                    { text: 'Ragione Sociale', value: 'business_name' }
                ]
            }
        },

        computed: {
            matchingFieldsLabel() {
                return this.matchingFields
                    .map(f => this.availableMatchingFields.find(a => a.value === f)?.text || f)
                    .join(' > ')
            }
        },

        methods: {

            downloadTemplate(url, filename) {
                this.$eventBusUtility.openFile(this.$store, url, filename)
            },

            uploadFile(url, file) {
                this.loading = true
                var formData = new FormData()
                formData.append('file', file)

                // Add import configuration
                formData.append('import_mode', this.importMode)
                this.matchingFields.forEach((field, index) => {
                    formData.append(`matching_fields[${index}]`, field)
                })
                formData.append('matching_logic', this.matchingLogicAnd ? 'all' : 'cascade')

                this.axios.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Accept': 'application/json'
                    }
                }).then(response => {
                    this.loading = false
                    this.$store.commit('setSnackbar', {timeout: 6000, text: 'Importazione Lead Avviata', value: true, color: 'success'})
                    this.leadsFile = null
                }, response => {
                    this.loading = false
                })
            },

            loadUsersOptions() {
                if (this.usersOptions.length > 0) return

                this.loadingUsers = true
                this.axios.get('/async-users')
                    .then(response => {
                        this.usersOptions = response.data
                        this.loadingUsers = false
                    })
                    .catch(error => {
                        console.error('Errore nel caricamento utenti:', error)
                        this.loadingUsers = false
                    })
            }
        },

        watch: {
            'settings.leads_notify_new': function(newVal) {
                if (newVal && this.usersOptions.length === 0) {
                    this.loadUsersOptions()
                }
            }
        }
    }
</script>

<style scoped>

</style>
